import { useEffect, useState } from "react";
import BackdropModalSmall from "../../components/modals/backdrop_modal_small";
import DatePicker from "react-datepicker";
import '../../styles/react-datepicker.css'; // Import the CSS



const DateTimeSelection = ({ isScheduleOpen,selectedDate=null,setSelectedDate,preselectedDate }) => {
 
 

  // Disable weekends (Saturday and Sunday)
  const isWeekday = (date) => {
    const day = date.getDay();
    return day !== 0 && day !== 6; // 0 = Sunday, 6 = Saturday
  };

  // Generate available time slots (from 7 AM to 5 PM, 15-minute intervals)
  const generateAvailableTimes = (selectedDate) => {
    const times = [];
    const now = new Date(); // Get the current date and time
  
    // Check if the selected date is today
    const isToday = selectedDate && selectedDate.toDateString() === now.toDateString();
  
    // Calculate the minimum time (1 hour from now)
    const minAvailableTime = new Date(now);
    minAvailableTime.setHours(now.getHours() + 1); // Add 1 hour to current time
  
    // Loop through available times (7 AM to 5 PM, 15-minute intervals)
    for (let h = 7; h <= 17; h++) {
      for (let m = 0; m < 60; m += 15) {
        const time = new Date();
        time.setHours(h, m, 0, 0);
  
        // Skip times that are before the "minimum available time" for today
        if (isToday && time < minAvailableTime) {
          continue; // Skip this time slot
        }
  
        // Add valid times to the list
        times.push(time);
      }
    }
  
    return times;
  };
  

 

  return (
    <div>
          <span className="d-block">Select Date and Time Schedule</span>

          {/* <DatePicker
        selected={selectedDate}
        onChange={(date) => setSelectedDate(date)}
        inline
        showTimeSelect
        dateFormat="Pp"
        timeIntervals={15}
        minDate={new Date()}
        filterDate={isWeekday}
        minTime={new Date().setHours(7, 0, 0)}
        maxTime={new Date().setHours(17, 0, 0)}
      /> */}

          <DatePicker
            selected={(new Date(preselectedDate) || selectedDate) || ""}
            onChange={(date) => {
              setSelectedDate(date);
            }}
            inline
            showTimeSelect
            dateFormat="Pp"
            timeIntervals={10} // Optional: Set intervals to 15 minutes
            minDate={new Date(new Date().setDate(new Date().getDate() + 1))}  // Minimum date is tmorrw
            filterDate={isWeekday} // Disable Saturdays and Sundays
            includeTimes={generateAvailableTimes(selectedDate)}
          />
 

          
    </div>
  );
};
 
export default DateTimeSelection;